import {
  filterNotUndefined,
  isNumber,
  mergeTyped,
  useDataStream,
  useEventAsStream,
  useStreamEffect,
  useStreamValue,
  useValueAsStream
} from 'annotation-tools/utils';
import { filter, withLatestFrom } from 'rxjs/operators';
import { updateModelPartially } from '../../../api/fetch-functions/model';
import { token$ } from '../../../global-state/auth-state';
import { fetchModelListOf } from '../../../global-state/database/model-list';
import { companyId$, modelId$ } from '../../../global-state/router-id';

export const useModelVersionHandler = (modelAdoptedVersionId: number) => {
  const selectedModelVersionIdServerValue$ = useValueAsStream(
    modelAdoptedVersionId
  );

  const [
    selectedModelVersionIdChange$,
    onSelectedModelVersionIdChange
  ] = useEventAsStream<number>();

  const selectedModelVersionId$ = useDataStream<number | undefined>(
    undefined,
    mergeTyped(
      selectedModelVersionIdServerValue$,
      selectedModelVersionIdChange$
    )
  );

  useStreamEffect(
    selectedModelVersionIdChange$.pipe(
      filter(isNumber),
      withLatestFrom(token$.pipe(filterNotUndefined()), companyId$, modelId$)
    ),
    ([selectedId, token, companyId, modelId]) => {
      updateModelPartially(token)(modelId)({
        adoptedVersionId: selectedId
      }).then(res => {
        if (res.type === 'success') {
          fetchModelListOf(companyId);
        }
      });
    }
  );

  const selectedModelVersionId = useStreamValue(selectedModelVersionId$);

  return {
    selectedModelVersionId,
    onSelectedModelVersionIdChange
  };
};
